/** Local previews must finish uploading before they can enter a task payload. */
export const hasOnlyUploadedMedia = (urls?: string[]) => !urls?.some((url) => /^(blob:|data:)/i.test(url))
